const isScorecard = (card: CanvasCard.Card): card is CanvasCard.ScorecardCard =>
  card.content.type === 'Scorecard';

export default isScorecard;
